const profiles = {
  header: {
    btnCreate: 'הוסף',
  },

  toast: {
    error: {
      badResponse: '[פרופילים] תגובת שרת שגויה',
      create: {},
      edit: {},
    },
    success: {
      create: {},
      edit: {},
      delete: {
        body: 'פרופילים נמחקו בהצלחה',
      },
    },
  },
  table: {
    headers: {
      name: 'שם',
      email: 'אימייל',
      phone: 'טלפון',
    },
    actions: {
      delete: 'מחק',
      export: 'ייצא',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
  forms: {
    header: {
      createProfile: {
        title: 'הוסף',
      },

      updateProfile: {
        title: 'עדכן',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'שמור',
        update: 'שמור',
      },
    },

    general: {
      header: 'כללי',
      fields: {
        profileType: {
          label: 'סוג פרופיל',
          options: {
            retail: 'קמעונאות',
            individual: 'פרטי',
            wholesale: 'סיטונאות',
            corporate: 'תאגידי',
            web: 'אינטרנט',
            hotel: 'מלון',
            thirdParty: 'צד שלישי',
            tourOperator: 'מפעיל תיירות',
            receiptiveOperator: 'מפעיל קולט',
          },
        },
        rateType: {
          label: 'סוג תעריף',
          options: {
            connections: 'חיבורים',
            corporate: 'תעריף תאגידי',
            expedia: 'Expedia',
            groundTransportation: 'תחבורה קרקעית',
            holidayTaxis: 'Holiday Taxis',
            respectiveOperator: 'תעריף מפעיל קולט',
            retail: 'תעריף קמעונאי',
            tourOperator: 'תעריף מפעיל תיירות',
            viator: 'Viator',
          },
        },
        name: {
          label: 'שם',
        },
        status: {
          label: 'סטטוס',
          options: {
            active: 'פעיל',
            inactive: 'לא פעיל',
            onHold: 'בהמתנה',
          },
        },
        sharedWith: {
          label: 'משותף עם',
        },
        email: {
          label: 'כתובת אימייל',
        },
        startDate: {
          label: 'תאריך התחלה',
        },
        phone: {
          label: 'מספר טלפון',
        },
        additionalPhone: {
          label: 'טלפון נוסף',
        },
        fax: {
          label: 'מספר פקס',
        },
        attributes: {
          label: 'מאפיינים',
        },
      },
    },
    billing: {
      header: 'מידע לחיוב',
      fields: {
        name: {
          label: 'שם לחיוב',
        },
        email: {
          label: 'כתובת אימייל',
        },
        phone: {
          label: 'מספר טלפון',
        },
        address: {
          label: 'כתובת',
        },
        city: {
          label: 'עיר',
        },
        state: {
          label: 'מדינה',
        },
        zip: {
          label: 'מיקוד',
        },
        country: {
          label: 'מדינה',
          options: {
            usa: 'ארה"ב',
          },
        },
      },
    },
    notes: {
      header: 'הערות',
      fields: {
        general: {
          label: 'כללי',
        },
        driver: {
          label: 'נהג',
        },
        dispatch: {
          label: 'שיגור',
        },
      },
    },
    complexNotes: {
      header: 'הערות',
      fields: {
        type: {
          label: 'סוג הערה',
          options: {
            accident: 'תאונה',
            complaint: 'תלונה',
            agentIssue: 'בעיה עם נציג (QC)',
            carIssue: 'בעיה עם רכב (QC)',
            noShow: 'לא הופיע',
            general: 'הערה כללית',
            disaptch: 'הערה לשיגור',
            driver: 'הערה לנהג',
            agent: 'הערת נציג',
            cancel: 'הערת ביטול',
            booking: 'הערת הזמנה',
          },
        },
        value: {
          label: 'תוכן הערה',
        },
      },
      add: 'הוסף הערה',
    },
    preferences: {
      header: 'העדפות הזמנה',
      job: {
        header: 'העדפות הזמנה',
        fields: {
          service: {
            label: 'שירות',
          },
          sharedWith: {
            label: 'משותף עם',
          },
        },
      },
      excludedDrivers: {
        header: 'נהגים שאינם כלולים',
        dualList: {
          driversList: {
            header: 'רשימת נהגים',
          },
          excludedList: {
            header: 'נהגים שאינם כלולים',
          },
        },
      },
      excludedVehicles: {
        header: 'רכבים שאינם כלולים',
        dualList: {
          vehiclesList: {
            header: 'רשימת רכבים',
          },
          excludedList: {
            header: 'רכבים שאינם כלולים',
          },
        },
      },
    },
    jobPreferences: {
      header: 'העדפות הזמנה',
      fields: {
        service: {
          label: 'שירות',
        },
        attributes: {
          label: 'מאפיינים',
        },
      },
    },
    jobHistory: {
      header: 'היסטוריית הזמנות',
      lastJob: 'הזמנה אחרונה: {{lastJob}}',
      firstJob: 'הזמנה ראשונה: {{firstJob}}',
    },
    contacts: {
      header: 'אנשי קשר',
      fields: {
        name: {
          label: 'שם איש קשר',
        },
        type: {
          label: 'סוג איש קשר',
          options: {
            sales: 'איש מכירות',
            employee: 'עובד',
          },
        },
        email: {
          label: 'אימייל',
        },
        phone: {
          label: 'מספר טלפון',
        },
        fax: {
          label: 'מספר פקס',
        },
        address: {
          label: 'כתובת',
        },
        city: {
          label: 'עיר',
        },
        state: {
          label: 'מדינה',
        },
        zip: {
          label: 'מיקוד',
        },
        country: {
          label: 'מדינה',
        },
        comment: {
          label: 'הערה',
        },
      },
      add: 'הוסף איש קשר',
    },
    rules: {
      header: 'כללים',
      fields: {
        value: 'ערך',
        discount: {
          label: 'הנחה',
          options: {
            none: 'ללא',
            fixed: 'קבוע',
            fixedPP: 'קבוע לכל נוסע',
            percent: 'אחוז',
            percentR: 'אחוז (מעוגל)',
            percentRU: 'אחוז (מעוגל כלפי מעלה)',
          },
        },
        markup: {
          label: 'תוספת מחיר',
          options: {
            none: 'ללא',
            fixed: 'קבוע',
            fixedPP: 'קבוע לכל נוסע',
            percent: 'אחוז',
            percentR: 'אחוז (מעוגל)',
            percentRU: 'אחוז (מעוגל כלפי מעלה)',
          },
        },
      },
    },
    passengers: {
      header: 'נוסעים',
      found: 'נמצאו {{number}} נוסעים',
      linkedTable: {
        title: 'רשימת נוסעים בפרופיל',
        columns: {
          passenger: 'נוסע',
          createdAt: 'תאריך יצירה',
          vip: 'VIP',
          registerWith: 'נוצר בתאריך',
          reservations: 'הזמנות',
        },
        actions: {
          clear: 'נקה סינון',
          remove: 'הסר נוסע',
        },
      },
      nonLinkedTable: {
        title: 'רשימת נוסעים לא מקושרים',
        columns: {
          passenger: 'נוסע',
          registerDate: 'תאריך יצירה',
          registerWith: 'נוצר בתאריך',
          profilesLinked: 'פרופילים מקושרים',
          reservations: 'הזמנות',
        },
        actions: {
          clear: 'נקה סינון',
          add: 'קשר נוסע',
        },
      },
    },
  },
  update: {
    success: {
      content: 'השינויים שלך נשמרו בהצלחה.',
    },
    error: {
      content: 'לא ניתן לשמור שינויים.',
    },
  },
  create: {
    success: {
      content: 'הפרופיל שלך נוצר.',
    },
    error: {
      content: 'לא ניתן ליצור פרופיל.',
    },
  },
  delete: {
    deleteBtn: 'מחק',
    deleteModal: {
      header: 'מחק פרופיל?',
      body: 'אתה עומד למחוק {{number}} פרופילים',
    },
  },
};

export default profiles;
